module.exports = __webpack_public_path__ + "static/media/img_8.68e86ac6.png";